export const sendEvent = (
  eventName,
  eventCategory,
  eventAction,
  variables = null
) => {
  if (!window.dataLayer) {
    return
  }

  if (!eventName || !eventCategory || !eventAction) {
    return
  }

  const data = {
    event: 'probots.event',
    'probots.event_label': eventName,
    'probots.event_category': eventCategory,
    'probots.event_action': eventAction,
  }

  // console.log('### sendEvent (sujet)', data, variables)
  window.dataLayer.push({ ...data, ...variables })
  // console.log(window.dataLayer)
}
